var exports = {
  "x6": "DiscoveryButton.module__button___aTNlb0",
  "td": "DiscoveryButton.module__iconText___aTNlb0",
  "yF": "DiscoveryButton.module__iconTextSelected___aTNlb0",
};

module.exports = exports;
